import { FieldType } from '@ngx-formly/core';
import * as _ from 'underscore';
import { distinctUntilChanged, pairwise, startWith } from 'rxjs/operators';
import { IExtraFieldConfigurationObject, IExtraTemplateOptions } from './ga-formly.service';

export abstract class ExtraFieldType extends FieldType {
  public to:IExtraTemplateOptions;
  public field:IExtraFieldConfigurationObject;
  public classNames:string;
  public key:string;
  private firstChange:boolean;

  protected listen():void {
    if (this.to.onChange) {
      this.formControl.valueChanges.pipe(
        startWith<any, any>(this.formControl.value),
        distinctUntilChanged(_.isEqual),
        pairwise()
      ).subscribe(([ oldValue, newValue ]:[ any, any ]) => {
        if (this.to.ignoreFirstOnChange && !this.firstChange) {
          this.firstChange = true;
          return;
        }
        this.to.onChange(newValue, oldValue);
      });
    }
  }
}